import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { FadeUp, MaskedLines, Eyebrow } from "@/components/Reveal";
import { PhoneFrame, MatchmakerScreen } from "@/components/PhoneMockup";

export default function Matchmaker({ showLink = true }) {
  return (
    <section
      data-testid="matchmaker-section"
      className="relative bg-burgundy-deep text-ivory py-24 sm:py-36 overflow-hidden"
    >
      <div aria-hidden="true" className="absolute -top-40 -left-40 w-[520px] h-[520px] rounded-full bg-burgundy/60 blur-3xl" />
      <div aria-hidden="true" className="absolute bottom-0 right-0 w-[420px] h-[420px] rounded-full bg-rose/10 blur-3xl" />

      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-16 items-center relative">
        <div>
          <FadeUp>
            <Eyebrow light>Çöpçatan Deneyimi</Eyebrow>
          </FadeUp>
          <h2 className="mt-7 font-serif text-3xl sm:text-4xl lg:text-5xl leading-[1.12] tracking-tight">
            <MaskedLines
              lines={[
                "Eşleşmenin arkasında",
                <em key="em" className="italic text-rose-soft">
                  bir insan dokunuşu.
                </em>,
              ]}
            />
          </h2>
          <FadeUp delay={0.2} className="mt-6 max-w-md text-base font-light text-ivory/75 leading-relaxed">
            Five Star yalnızca bir eşleşme ekranı değildir. Süreç boyunca çöpçatan desteği alabilir, geri
            bildirimlerde bulunabilir ve gerektiğinde yönlendirme alabilirsin.
          </FadeUp>
          {showLink && (
            <FadeUp delay={0.4} className="mt-10">
              <Link to="/konsiyerj" data-testid="matchmaker-more-link" className="link-ghost-light">
                Çöpçatan deneyimini keşfet
                <ArrowRight className="w-4 h-4" aria-hidden="true" />
              </Link>
            </FadeUp>
          )}
        </div>

        <div className="relative flex justify-center">
          <FadeUp delay={0.15}>
            <PhoneFrame>
              <MatchmakerScreen />
            </PhoneFrame>
          </FadeUp>
          <FadeUp
            delay={0.45}
            className="hidden xl:block absolute -right-4 top-14 w-56 bg-ivory-light text-ink rounded-[6px] border border-gold/30 p-5 shadow-[0_20px_50px_rgba(0,0,0,0.35)]"
          >
            <p className="text-[10px] uppercase tracking-[0.22em] text-burgundy/70 font-semibold">Çöpçatan Notu</p>
            <p className="mt-2 font-serif text-base leading-snug">
              &ldquo;Elif ile ortak ilgi alanlarınız güçlü görünüyor.&rdquo;
            </p>
          </FadeUp>
          <FadeUp
            delay={0.6}
            className="hidden xl:block absolute -left-6 bottom-16 w-56 bg-ivory-light text-ink rounded-[6px] border border-gold/30 p-5 shadow-[0_20px_50px_rgba(0,0,0,0.35)]"
          >
            <p className="text-[10px] uppercase tracking-[0.22em] text-burgundy/70 font-semibold">Geri Bildirim</p>
            <p className="mt-2 font-serif text-base leading-snug">Bildirimin, bir sonraki The Five&rsquo;ı şekillendirir.</p>
          </FadeUp>
        </div>
      </div>
    </section>
  );
}
